var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetQuoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.66406H14.5",
    stroke: "#22428F",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4H11.8333",
    stroke: "#22428F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.66927V7.33594C14.5 4.50751 14.5 3.0933 13.6213 2.21462C12.7427 1.33594 11.3284 1.33594 8.5 1.33594C5.67157 1.33594 4.25736 1.33594 3.37868 2.21462C2.5 3.0933 2.5 4.50751 2.5 7.33594V8.66927C2.5 11.4977 2.5 12.9119 3.37868 13.7906C4.25736 14.6693 5.67157 14.6693 8.5 14.6693C11.3284 14.6693 12.7427 14.6693 13.6213 13.7906C14.5 12.9119 14.5 11.4977 14.5 8.66927Z",
    stroke: "#22428F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16406 9.33594H5.51494M8.32193 9.33594H8.67286M11.4799 9.33594H11.8307",
    stroke: "#22428F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16406 12H5.51494M8.32193 12H8.67286M11.4799 12H11.8307",
    stroke: "#22428F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetQuoteIcon);
export default __webpack_public_path__ + "static/media/get-quote-icon.764a2e561d7ef3f3f1dc5a42435df3a5.svg";
export { ForwardRef as ReactComponent };